module.exports = __webpack_public_path__ + "static/media/logo_waytogo.474beaf5.png";